// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"bGvh5":[function(require,module,exports) {
require("7e1c65c8d3c72b67").register(require("f782455dd7b682db").getBundleURL("8aiQJ"), JSON.parse('["8aiQJ","index.73217c89.js","aTaOl","frame-21-2.5a555d7e.svg","cUnG9","frame-17-2.3151b1fc.svg","iKHsl","worker.2a57633e.png","aUeSl","placeholder.512da104.png","58UsJ","trailbluvideo.34f4d9e4.mp4","gLQS5","coloredFibaBanka.7fb2db4a.png","bjxek","coloredAktifBank.e775bc59.png","esctD","osigoLogo.92b5039a.png","7rJiw","imeceLogo.b0b331fc.png","8VjZD","turkiyesigorta.8352a9cd.png","gKTCN","mobile-web-app-testing.633577fe.svg","b7hhc","data-driven-testing.2b1a8bb7.svg","hov5e","visual-testing.d059f405.svg","21fYx","frame-17-1.cda09989.svg","jFwu9","frame-17.f0731216.svg","bvGYP","Logo.d59ea1f7.png","iQfvK","menuIcon.fb1f72dc.png","dUHkU","footer.37a846b1.png","i4zvC","capterra.7a47a480.svg","gfO5R","getApp.8409d752.png","48PSg","TrailbluIntro.da3a49e6.png","2Ysfk","profile.39da575e.jpg","asdn7","visualTesting.b8854283.png","ci9Gz","generativeAI.d26a072a.png","ca7YK","qatar_event.3f6c769a.png","0Eu4B","p21.2fae429a.png","9xfKI","flutterTesting.681fa9ee.png","kKvNi","p31.f76b6ba5.png","gGs68","revolutionizetestingAI1.66f9e73c.png","4eQyk","codelessAutomated.1be6be62.png","6LtQP","ContinuousTesting2.b7b703d0.png","kGpfA","RegressionTesting1.1da52bb4.png","65U7R","scalingSoftwareTestingAI.4aba1723.png","9LvGp","endToEndTesting.d91249bc.png","gHZYT","crossDeviceTesting.0a9daeae.png","5SCzY","profitCenterTesting.3683948c.png","3Ivm8","seleniumPlaywrightTesting.6cda924c.png","dakBz","deviceFarm.b2b9133f.png","askht","testAutomation.f03e5450.png","hKeMk","validationVerification.8750bbdc.png","dopHZ","p3.6cbcf2e9.png","jvnkU","p2.52b2dcd2.png","ehfof","p22.9e5f4266.png","970Rf","flutterTesting2.b736b2e4.png","fFSNg","flutterTesting3.ad603ff4.png","F0faH","generativeAI2.13235141.png","kJl7J","generativeAI3.b568445d.png","iDmNy","qatar.31be1fe7.png","fBfW1","qatar_event2.7bc86066.png","7dyAg","revolutionizetestingAI2.e31dd0c4.png","9IhsF","ContinuousTesting1.fdf53e31.png","kowRY","TrailbluNoCodeTesting.61ac6ae4.gif","6tDDU","TrailbluSelfHealing.07b6d22b.gif","cPo8z","TrailbluVisualTesting.36235996.gif","4JoPH","TrailbluGenAI.0b2ac43b.gif","7sFlc","killerFeatureGenAI.7ec76e29.png","kqNFc","killerFeatureNoCode.99673061.png","jlt0A","killerFeatureSelfHealing.db589f7d.png","UIXqz","killerFeatureVisualTesting.e19e0d06.png","5xtVq","1write.bb0c16f7.svg","jQlZ5","2groupOfPeople.9bf9a387.svg","2XjZF","3RocketLaunching.df79e9c8.svg","dFG9q","4FixedSetting.9dc42b11.svg","iQ5NK","1puzzle-piece.f26e506e.svg","5YEcC","2stopwatch.168e76b4.svg","4Pnzg","3shield.1cf4f3d3.svg","3mCQG","4danger.ec699758.svg","bjRHH","5transparency.2ad7ee61.svg","eCd00","6quality.fb71439b.svg","3qTNE","1magnifying-glass.149046e5.svg","fqxlk","2target.342a8945.svg","bBzOF","3responsive.0b62c3c7.svg","awnIR","4screenshot.c2043cf9.svg","b4mV1","5analyzing.5c62edc9.svg","77bVp","1guarantee.d361dc46.svg","aaL7c","2automatic.fc813c8d.svg","65p5Q","3shield-update.22ef117d.svg","dIXLL","4increasing-bar.615c73ce.svg","brXBg","5decreasing-bar.f0fb167e.svg","jkuoZ","index.1ab216b7.css"]'));

},{"7e1c65c8d3c72b67":"fyJL2","f782455dd7b682db":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["bGvh5"], null, "parcelRequireb8e7")

//# sourceMappingURL=index.runtime.c617bb10.js.map
